@if (externalLinkForm) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="externalLinkForm">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Text </label>
            </div>
            <clickatell-form-validation [controlName]="'text'"
            [form]="externalLinkForm"></clickatell-form-validation>
            <textarea class="control-textArea" activeForm [activeForm]="externalLinkForm" id="text" [formControlName]="'text'"
            style="resize: none"></textarea>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> URL </label>
            </div>
            <clickatell-form-validation [controlName]="'url'"
            [form]="externalLinkForm"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="externalLinkForm" id="url"
              [formControlName]="'url'" placeholder="Enter a url"/>
            </div>
          </ng-container>
        </ng-container>
      </clickatell-expansion-panel>
      <clickatell-expansion-panel>
        <ng-container header>
          <mat-panel-title>
            Logic
          </mat-panel-title>
        </ng-container>
        <ng-container body>
          <ng-container [formGroup]="logicForm">
            <div class="control-div">
              <div class="addBtnContainer">
                <button class="addIcon" (click)="addResult()">Add New</button>
              </div>
            </div>
            @for (resultsForm of logicForm?.controls['results']?.controls; track resultsForm; let i = $index) {
              <ng-container
                formArrayName="results">
                <div class="control-result" [formGroup]="resultsForm">
                  <div class="control-result-header">
                    @if (resultsForm.controls.result.value) {
                      {{ resultsForm.controls.result.value }}
                    } @else {
                      <span class="control-result-defaultTitle">
                        [Result Name]
                      </span>
                    }
                    @if (resultsForm.controls.result.value !== 'other') {
                      <button class="control-result-delete"
                        (click)="deleteResult('results', i)">
                        <img class="control-result-delete-btn" src="./assets/svg/redesign/trash.svg">
                      </button>
                    }
                  </div>
                  <div class="control-result-container">
                    <div class="control-div">
                      <div class="control-label-button-wrapper">
                        <div class="control-label-container">
                          <label class="control-label"> Result </label>
                        </div>
                      </div>
                      <clickatell-form-validation [controlName]="'result'"
                      [form]="resultsForm"></clickatell-form-validation>
                      <input class="control-input" activeForm [activeForm]="resultsForm" id="result"
                        [formControlName]="'result'" placeholder="Enter a result"/>
                      </div>
                      <div class="control-div">
                        <div class="control-label-container">
                          <label class="control-label"> Description </label>
                        </div>
                        <clickatell-form-validation [controlName]="'description'"
                        [form]="resultsForm"></clickatell-form-validation>
                        <input class="control-input" activeForm [activeForm]="resultsForm" id="description"
                          [formControlName]="'description'" placeholder="Enter a description"/>
                        </div>
                        <div class="control-div">
                          <label class="control-label">
                            <span class="pont-to">Point To</span>
                            <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                          </label>
                          @if (nodeFlowDetails) {
                            <next-selector [canEditFlows]="canEdit.canEditFlows"
                              [selectorType]="'both'"
                              [flowSteps]="nodeFlowDetails.currentFlowSteps"
                              [flows]="nodeFlowDetails.flows"
                              [name]="'next'"
                              [form]="resultsForm"
                              [stepId]="nodeFlowDetails.stepId">
                            </next-selector>
                          }
                        </div>
                      </div>
                    </div>
                  </ng-container>
                }
              </ng-container>
            </ng-container>
          </clickatell-expansion-panel>
        </div>
      }